import script from "./UpdateList.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpdateList.vue?vue&type=script&lang=ts&setup=true"

import "./UpdateList.vue?vue&type=style&index=0&id=211b266b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-211b266b"]])

export default __exports__